var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.313,
    height: 13.316,
    viewBox: "0 0 13.313 13.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_30",
    "data-name": "Union 30",
    d: "M17832.023-2740.566l-4.951-4.949-4.949,4.949a1,1,0,0,1-1.416,0,1,1,0,0,1,0-1.414l4.949-4.949-4.949-4.947a1,1,0,0,1,0-1.414,1,1,0,0,1,1.416,0l4.947,4.947,4.953-4.951a1,1,0,0,1,1.414,0,1,1,0,0,1,0,1.414l-4.951,4.951,4.951,4.949a1,1,0,0,1,0,1.414,1,1,0,0,1-.709.3A.986.986,0,0,1,17832.023-2740.566Z",
    transform: "translate(-17820.416 2753.587)",
    fill: "#e1e6eb"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.0e7997d3badbc0a1e1b6803d6e7fe934.svg";
export { ForwardRef as ReactComponent };